import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  //   TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
// import AppConfig from "appConfig";
import { useAuthUser } from "react-auth-kit";

function AttendancesPage() {
  const pageTitle = "Agent Attendances";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [attendances, setAttendances] = useState([]);
  const [title, setTitle] = useState(null);
  const [checkInTime, setCheckInTime] = useState(null);
  const [checkOutTime, setCheckOutTime] = useState(null);
  const [gracePeriod, setGracePeriod] = useState(null);
  const [enforceFaceMatch, setEnforceFaceMatch] = useState(null);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packages, setPackages] = useState([]);
  const [openPackagesDialog, setOpenPackagesDialog] = useState(false);

  function generateTimeArray() {
    const startTime = new Date();
    const endTime = new Date();
    startTime.setHours(0, 0, 0, 0);
    endTime.setHours(23, 59, 0, 0);

    const timeArray = [];
    const currentTime = new Date(startTime);

    while (currentTime <= endTime) {
      const hours = String(currentTime.getHours()).padStart(2, "0");
      const minutes = String(currentTime.getMinutes()).padStart(2, "0");
      timeArray.push(`${hours}:${minutes}`);
      currentTime.setMinutes(currentTime.getMinutes() + 30);
    }

    return timeArray;
  }

  const timeArray = generateTimeArray();

  async function deleteAttendance(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/attendances/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const attendancesTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Package", accessor: "package", align: "left" },
    { Header: "Resumption Time", accessor: "check_in", align: "center" },
    { Header: "Closing Time", accessor: "check_out", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        package: row.package,
        check_in: row.check_in_time,
        check_out: row.check_out_time,
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Attendance Logs">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/attendances/records/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  list
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Manage Tracker">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  navigate(`/attendances/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  settings
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  deleteAttendance(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/attendances.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPackages(result.data.data.packages);
            const rows = buildRows(result.data.data.attendances);
            setAttendances(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createAttendance() {
    if (selectedPackage === null) {
      setSeverity("error");
      setErrMsg("Please select a plan.");
      setOpen(true);
      return;
    }

    if (title === null) {
      setSeverity("error");
      setErrMsg("Attendance name is required.");
      setOpen(true);
      return;
    }

    if (checkInTime === null) {
      setSeverity("error");
      setErrMsg("Check-in time is required.");
      setOpen(true);
      return;
    }

    setOpenCreateDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
      package: selectedPackage,
      check_in_time: checkInTime,
      check_out_time: checkOutTime,
      grace_period: gracePeriod,
      enforce_face_match: enforceFaceMatch,
    };

    await axios
      .post("portal/attendances/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openPackagesDialog} fullWidth maxWidth="md">
        <DialogTitle>
          <MDBox align="center" mb={3}>
            Plans
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <Grid container spacing={3}>
              {packages.map((pckg, idx) => (
                <Grid item xs={12} md={4} lg={4}>
                  <Card>
                    <MDBox p={0}>
                      <MDBox align="center" mt={1}>
                        <MDTypography variant="h6">{pckg.title}</MDTypography>
                        <MDTypography fontSize={14}>{`${accountInfo.account.currency}${(
                          pckg.price / 100
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}</MDTypography>
                        <MDTypography fontSize={12}>30 days</MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Check-Ins</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.check_ins.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Face Check</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                <Icon color="success">check_circle</Icon>
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Bio-metric Check</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                <Icon color="success">check_circle</Icon>
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Check-Outs</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                <Icon color="success">check_circle</Icon>
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Spoof Guard</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {idx > 0 ? (
                                  <Icon color="success">check_circle</Icon>
                                ) : (
                                  <Icon color="error">clear</Icon>
                                )}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPackagesDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openCreateDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>New Attendance Tracker</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={0} mb={3}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Plan</InputLabel>
                <Select
                  label="Select Plan"
                  onChange={(e) => {
                    setSelectedPackage(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {packages.map((pckg) => (
                    <MenuItem value={pckg.reference}>{pckg.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={5}>
              <MDInput
                value={title}
                name="title"
                margin="dense"
                label="Tracker Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>

            <MDBox mt={4}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox>
                    <FormControl fullWidth>
                      <InputLabel>Resumption Time</InputLabel>
                      <Select
                        label="Resumption Time"
                        onChange={(e) => {
                          setCheckInTime(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        value={checkInTime}
                      >
                        {timeArray.map((row) => (
                          <MenuItem value={row}>{row}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox>
                    <FormControl fullWidth>
                      <InputLabel>Closing Time (Optional)</InputLabel>
                      <Select
                        label="Closing Time (Optional)"
                        onChange={(e) => {
                          setCheckOutTime(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        value={checkOutTime}
                      >
                        <MenuItem value={null}>---</MenuItem>
                        {timeArray.map((row) => (
                          <MenuItem value={row}>{row}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                name="attendance_grace_period"
                margin="dense"
                label="Grace Period (Minutes)"
                type="number"
                value={gracePeriod}
                fullWidth
                variant="outlined"
                onChange={(e) => setGracePeriod(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={enforceFaceMatch}
                onChange={(e) => {
                  setEnforceFaceMatch(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enforce bio-metric face check?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createAttendance();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>

      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>recent_actors</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                        <b>Attendance tracking for your teams.</b>
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={14}>
                        Track actual GPS location, time of day and much more.
                        <br />
                        Lock attendance to specific locations by geo-fencing attendance entries.
                        <br />
                        Enforce biometric facial checks to combat identity fraud.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={5} mb={3}>
                      <MDButton
                        color="warning"
                        onClick={() => setOpenPackagesDialog(true)}
                        variant="outlined"
                        startIcon={<>{accountInfo.account.currency}</>}
                      >
                        View Pricing
                      </MDButton>
                      &nbsp;&nbsp;
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setTitle(null);
                          setOpenCreateDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Create Tracker
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Attendance Trackers
                        </MDTypography>
                      </MDBox>
                      {/* <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                        <MDBox>
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setTitle(null);
                              setOpenCreateDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox> */}
                    </MDBox>
                  </MDBox>
                  <MDBox p={0}>
                    <DataTable
                      table={{ columns: attendancesTableColumns, rows: attendances }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AttendancesPage;
